import eraDefinitions from './gen_era_definitions.json';

interface EraDefinition {
    id: string;
    eraUnitId: string[];
    startTimeMs: number;
    endTimeMs: number;
}

// Build a lookup map from unit baseId to era definition at import time.
const unitToEra = new Map<string, EraDefinition>();
export const activeEraUnits: Set<string> = new Set<string>();
export let activeEra: EraDefinition | null = null;

for (const era of Object.values(eraDefinitions) as EraDefinition[]) {
    const now = Date.now();
    const isActive = now >= era.startTimeMs && now < era.endTimeMs;
    if (isActive)
        activeEra = era;
    for (const unitId of era.eraUnitId) {
        unitToEra.set(unitId, era);
        if (isActive)
            activeEraUnits.add(unitId);
    }
}

export function isActiveEraUnit(baseId: string): boolean {
    const era = unitToEra.get(baseId);
    if (!era) return false;
    const now = Date.now();
    return now >= era.startTimeMs && now < era.endTimeMs;
}

export function getEraEndDate(baseId: string): Date | null {
    const era = unitToEra.get(baseId);
    if (!era) return null;
    return new Date(era.endTimeMs);
}
